import { useMemo } from 'react';
import useCurrentUser from './useCurrentUser';
import { getPermissionForSection } from '../util/permissionUtils';

const useSectionPermission = (sectionName: string) => {
  const currentUser = useCurrentUser();
  return useMemo(() => {
    if (currentUser && currentUser.permissions) {
      return getPermissionForSection(currentUser.permissions, sectionName);
    }
    return false;
  }, [currentUser, sectionName]);
};

export default useSectionPermission;
